import { render, staticRenderFns } from "./view-item.vue?vue&type=template&id=5d7b970e&scoped=true&"
import script from "./view-item.vue?vue&type=script&lang=js&"
export * from "./view-item.vue?vue&type=script&lang=js&"
import style0 from "./view-item.vue?vue&type=style&index=0&id=5d7b970e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b970e",
  null
  
)

export default component.exports